export default function EmptyIcon(props: { width?: number; height?: number }) {
  return (
    <svg
      width="184"
      height="115"
      viewBox="0 0 184 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M92 115.002C142.81 115.002 184 106.059 184 95.0264C184 83.9942 142.81 75.0508 92 75.0508C41.1898 75.0508 0 83.9942 0 95.0264C0 106.059 41.1898 115.002 92 115.002Z"
        fill="#F5F5F5"
      />
      <path
        d="M158.125 37.2682L128.955 4.44537C127.555 2.2081 125.511 0.855469 123.358 0.855469H60.6424C58.489 0.855469 56.4449 2.2081 55.0447 4.44252L25.875 37.271V63.636H158.125V37.2682Z"
        stroke="#D9D9D9"
      />
      <path
        d="M119.637 46.3172C119.637 41.7371 122.495 37.956 126.04 37.9531H158.125V89.7099C158.125 95.7682 154.33 100.734 149.644 100.734H34.3562C29.67 100.734 25.875 95.7654 25.875 89.7099V37.9531H57.96C61.5049 37.9531 64.3626 41.7285 64.3626 46.3086V46.3714C64.3626 50.9515 67.252 54.6499 70.794 54.6499H113.206C116.748 54.6499 119.637 50.9173 119.637 46.3372V46.3172Z"
        fill="#FAFAFA"
        stroke="#D9D9D9"
      />
    </svg>
  );
}
